import React, { useEffect, useState } from "react";
import "./accountmodal.css";
import { toast } from "sonner";
import axios from "axios";

const blockedDomains = ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com"];

const AccountModal = ({ isOpen, onClose, product }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    function scrollNotifications() {
      var element = document.getElementById("scrollDiv");
      element.scrollTop = -element.scrollHeight;
    }

    scrollNotifications();
  }, []);

  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) return toast.error("Please enter your email.");

    const string = name.trim().replace(/\s+/g, "");

    if (string.length < 3) {
      toast.error("Please enter correct name");
      return;
    }

    if (!EMAIL_REGEX.test(email)) {
      toast.error("Oops! That email doesn’t seem right. Try again?");
      return;
    }

    const domain = email?.split("@")[1]?.toLowerCase();
    if (blockedDomains?.includes(domain)) {
      toast.error("Personal emails aren’t allowed. Try using your work email.");
      return;
    }

    const payload = {
      user_name: name,
      user_org: company,
      user_business_email: email,
      product: product,
    };

    try {
      setLoading(true);
      const url = `https://hij33pcou7kpcwh7tqx4drviwq0exsvx.lambda-url.ap-south-1.on.aws/`;
      const res = await axios.post(url, payload);
      toast.success("All set! Our team will connect with you soon.");
      onClose();
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          "We’re facing a tiny glitch. Hang tight and retry."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`modal-overlay1 ${isOpen ? "show" : ""}`}
        onClick={onClose}
      />
      <div id="scrollDiv" className={`center-modal1 ${isOpen ? "show" : ""}`}>
        <div className="account-right-container">
          <div className="account-cont-header">
            <h1>
              <span>We’ll</span> Take It From Here
            </h1>
            <img
              src="/images/Button.svg"
              alt="X"
              className="verify-cross-btn"
              onClick={onClose}
            />
          </div>

          <div className="account-para">
            Just share your details, and our team will get in touch soon.
          </div>

          <form className="form-data1" onSubmit={handleSubmit}>
            <div className="form-inputs1">
              <label>
                Your Name<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="John Doe"
                value={name}
                onChange={(e) =>
                  setName(e.target.value.replace(/[^a-zA-Z\s]/g, ""))
                }
              />
            </div>

            <div className="form-inputs1">
              <label>
                Your Company<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="ABC Industries"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              />
            </div>
            <div className="form-inputs1">
              <label>
                Business Email<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                placeholder="john@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button type="submit" className="submit-div1" disabled={loading}>
              {loading ? "Submitting..." : "Get Started"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default AccountModal;
